/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Filters_No_ResultsInputs */

const en_admin_resources_filters_no_results = /** @type {(inputs: Admin_Resources_Filters_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results match. Try adjusting your filters.`)
};

const de_admin_resources_filters_no_results = /** @type {(inputs: Admin_Resources_Filters_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine passenden Ergebnisse. Versuche, deine Filter anzupassen.`)
};

const es_admin_resources_filters_no_results = /** @type {(inputs: Admin_Resources_Filters_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún resultado coincide. Prueba a ajustar los filtros.`)
};

const fr_admin_resources_filters_no_results = /** @type {(inputs: Admin_Resources_Filters_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun résultat ne correspond. Essayez d'ajuster vos filtres.`)
};

const nl_admin_resources_filters_no_results = /** @type {(inputs: Admin_Resources_Filters_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen resultaten. Pas je filters aan.`)
};

/** @type {(inputs: Admin_Resources_Filters_No_ResultsInputs) => LocalizedString} */
const it_admin_resources_filters_no_results = en_admin_resources_filters_no_results;

/** @type {(inputs: Admin_Resources_Filters_No_ResultsInputs) => LocalizedString} */
const pt_br2_admin_resources_filters_no_results = en_admin_resources_filters_no_results;

/** @type {(inputs: Admin_Resources_Filters_No_ResultsInputs) => LocalizedString} */
const pl_admin_resources_filters_no_results = en_admin_resources_filters_no_results;

/** @type {(inputs: Admin_Resources_Filters_No_ResultsInputs) => LocalizedString} */
const hu_admin_resources_filters_no_results = en_admin_resources_filters_no_results;

/** @type {(inputs: Admin_Resources_Filters_No_ResultsInputs) => LocalizedString} */
const ro_admin_resources_filters_no_results = en_admin_resources_filters_no_results;

/**
* | output |
* | --- |
* | "No results match. Try adjusting your filters." |
*
* @param {Admin_Resources_Filters_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_filters_no_results = /** @type {((inputs?: Admin_Resources_Filters_No_ResultsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Filters_No_ResultsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_filters_no_results(inputs)
	if (locale === "de") return de_admin_resources_filters_no_results(inputs)
	if (locale === "es") return es_admin_resources_filters_no_results(inputs)
	if (locale === "fr") return fr_admin_resources_filters_no_results(inputs)
	if (locale === "nl") return nl_admin_resources_filters_no_results(inputs)
	if (locale === "it") return it_admin_resources_filters_no_results(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_filters_no_results(inputs)
	if (locale === "pl") return pl_admin_resources_filters_no_results(inputs)
	if (locale === "hu") return hu_admin_resources_filters_no_results(inputs)
	return ro_admin_resources_filters_no_results(inputs)
});
export { admin_resources_filters_no_results as "admin.resources.filters_no_results" }